<template>
  <div class="fund-basic">
    <MoreTitle title="基本资料" />
    <div class="row-wrapper">
      <RowInfo label="ETF名称">{{ $digitjs(data.cnName).isNull() }}</RowInfo>
      <RowInfo label="管理人">{{ $digitjs(data.etfCustodian).isNull() }}</RowInfo>
      <RowInfo label="发行方">{{ $digitjs(data.issuerName).isNull() }}</RowInfo>
      <RowInfo label="发行时间">{{ $digitjs(data.etfListingDate).isNull() }}</RowInfo>
      <RowInfo label="分配频率">{{ $digitjs(data.dividendDistribution).isNull() }}</RowInfo>
    </div>
  </div>
</template>

<script>
import RowInfo from '@/components/common/RowInfo.vue'
import EllipsisText from '@/components/common/EllipsisText'
export default {
  components: { RowInfo, EllipsisText },
  props: ['data'],
  methods: {
    getAssetsUnderManagement(value) {
      const money = this.$digitjs(parseFloat(value)).convert()
      const date = this.$digitjs(value)
        .isNull()
        .match(/\((.+?)\)/g)?.[0]
      return money + date
    }
  }
}
</script>

<style lang="scss" scoped>
.fund-basic {
  padding: 0 var(--edge-padding) var(--edge-padding);
  background: var(--bg-color-2);
}
</style>
